/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Group_StudentsInputs */

const en_us2_coaching_group_students = /** @type {(inputs: Coaching_Group_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students`)
};

const pt_br2_coaching_group_students = /** @type {(inputs: Coaching_Group_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alunos`)
};

const pt_pt2_coaching_group_students = /** @type {(inputs: Coaching_Group_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alunos`)
};

/** @type {(inputs: Coaching_Group_StudentsInputs) => LocalizedString} */
const es_419_coaching_group_students = en_us2_coaching_group_students;

/** @type {(inputs: Coaching_Group_StudentsInputs) => LocalizedString} */
const fr_fr2_coaching_group_students = en_us2_coaching_group_students;

/** @type {(inputs: Coaching_Group_StudentsInputs) => LocalizedString} */
const de_de2_coaching_group_students = en_us2_coaching_group_students;

/** @type {(inputs: Coaching_Group_StudentsInputs) => LocalizedString} */
const it_it2_coaching_group_students = en_us2_coaching_group_students;

/**
* | output |
* | --- |
* | "Students" |
*
* @param {Coaching_Group_StudentsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_group_students = /** @type {((inputs?: Coaching_Group_StudentsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Group_StudentsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_group_students(inputs)
	if (locale === "es-419") return es_419_coaching_group_students(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_group_students(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_group_students(inputs)
	if (locale === "de-DE") return de_de2_coaching_group_students(inputs)
	if (locale === "it-IT") return it_it2_coaching_group_students(inputs)
	return en_us2_coaching_group_students(inputs)
});
export { coaching_group_students as "coaching.group_students" }